import { formatCurrency } from '@/lib/payments';

interface PmsBalanceNoteProps {
  memberName: string;
  /** Amount PMS pays now; null while the form amount is not valid yet. */
  amount: number | null;
  /** The member's balance due before this payment. */
  currentBalance: number;
}

/** Shown when Paid by PMS is selected: what will be added to the member's balance. */
export function PmsBalanceNote({ memberName, amount, currentBalance }: PmsBalanceNoteProps) {
  return (
    <div className="rounded-lg border border-amber-200 bg-amber-50 px-4 py-2.5 text-[13px] text-amber-900">
      <b>{amount !== null ? formatCurrency(amount) : '--'}</b> will be added to {memberName}'s balance at 12% per year.
      Balance after: <b>{formatCurrency(currentBalance + (amount ?? 0))}</b>
    </div>
  );
}
